import React from 'react'
import { OmButton, OmTabs, omNotification } from '@owma/kit'

import i18n from 'i18n'
import classNames from 'classnames'
import { i18Key } from 'utils'
import { getTempEnvParam } from 'env'

import { UIGroup, ViewGroup } from 'utils/ui/propsUI'

import settings, { getCustomSendAsSelect, getCustomSignatureSelect } from 'popups/Settings'
import { openManageSignature } from 'popups/ManageSignature'
import { openManageSenders } from 'popups/ManageSenders'
import { openManageServerRules } from 'popups/ManageServerRules'

import { basicColors, isEmail } from 'utils/ui'
import ColorButton from 'pages/calendar/components/common/ColorButton'
import ForwardingPanel from './ForwardingPanel'
import AppPasswordPanel from './AppPasswordPanel'
import SendAsPanel from './SendAsPanel'
import AutomaticRepliesPanel from './AutomaticRepliesPanel'
import styles from './style.module.scss'
import { SettingsInterface } from '../def'

interface AccountsSettingsProps {
  innerRef?: React.MutableRefObject<SettingsInterface | null>
  owner: any
  isMobile?: boolean
  parentLabel?: any
  idx?: string | number
}

interface AccountsSettingsState {
  sendAsAccounts: any[]
  activeKey?: string
}

class SettingItem
  extends React.Component<AccountsSettingsProps, AccountsSettingsState>
  implements SettingsInterface
{
  state: AccountsSettingsState = { sendAsAccounts: [] }

  uiGroupMap: Record<string, any> = {}

  _removeRemainTimer: ReturnType<typeof setTimeout> | null = null

  componentDidMount(): void {
    const { innerRef } = this.props
    if (innerRef != null) {
      innerRef.current = this
    }

    this.applySettings()
  }

  // componentDidUpdate(prevProps) {
  //   const { mailbox, selectedEmail } = this.props
  // }

  componentWillUnmount(): void {
    if (this._removeRemainTimer != null) {
      clearTimeout(this._removeRemainTimer)
    }
  }

  getCustomColorSelector = (): any => {
    let currentColor = basicColors[0]
    return {
      onGetValue: (info: any, wrapper: any) => {
        console.log('customContactSelect onGetValue : ', wrapper, info)
      },
      onSetValue: (value: any, info: any, wrapper: any) => {
        console.log('customContactSelect onSetValue : ', wrapper, info, value)
        currentColor = value
      },
      getElement: (info: any, wrapper: any) => {
        const { reactObj } = wrapper
        // const { owner } = reactObj.props
        return (
          <ColorButton
            showName={true}
            color={currentColor}
            onChange={(value: any) => {
              reactObj.onPropsChange('accountColor', value)

              currentColor = value
            }}
          />
        )
      },
    }
  }

  createAccountUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        titleKey: null,
        descKey: null,
      }),
    ]

    const customObjChangePassword: any = {
      onGetValue: (/* info, wrapper */) => {},
      onSetValue: (/* value, info, wrapper */) => {},
      getElement: (/* info, */ wrapper: any) => {
        const onClick = async () => {
          try {
            const { openChangePassword } = await import('services/landing')
            await openChangePassword()
          } catch (err) {
            // password-change-url API 실패 등으로 reject 시 unhandled rejection 차단 + 사용자 안내
            // (OFFICEMAIL-WEB-ACCESS-JR: RestClientError OfficeNext password-status API failed)
            console.warn('[ChangePassword] openChangePassword failed', err)
            omNotification.error({
              message: i18n.t('settings.changePasswordFailed'),
              description: i18n.t('settings.changePasswordFailedDesc'),
            })
          }
        }

        return (
          <OmButton key={wrapper.pKey} className={classNames('type3', 'h38')} onClick={onClick}>
            {i18n.t('settings.btns.changePassword')}
          </OmButton>
        )
      },
    }

    const rawServices = getTempEnvParam('app.services')
    // app.services 는 로그아웃(강제 로그아웃 포함) 정리 시 제거될 수 있어 pages 를 항상 객체로 방어.
    const services = {
      ...(rawServices ?? {}),
      pages: rawServices?.pages ?? {},
    }

    const accountProps: any = {
      accountName: {
        labelKey: i18Key('settings.fields.displayName'),
        readOnly: false,
        format: 'om-input',
        default: '',
        vGroup: vGroups[0],
      },
      accountColor: {
        labelKey: i18Key('settings.fields.color'),
        readOnly: false,
        format: 'custom',
        ...this.getCustomColorSelector(),
        vGroup: vGroups[0],
      },
      accountSenderName: {
        use: services.pages.email === true,
        labelKey: i18Key('settings.fields.senderName'),
        readOnly: false,
        format: 'om-input',
        default: '',
        vGroup: vGroups[0],
      },
      changePassword: {
        labelKey: i18Key('settings.fields.changePassword'),
        format: 'custom',
        ...customObjChangePassword,
        vGroup: vGroups[0],
      },
    }

    this.uiGroupMap.account = new UIGroup({
      children: accountProps,
      styles,
      reactObj: this,
    })
  }

  // createMailboxUIGroup = () => {
  //   const vGroups = [
  //     new ViewGroup({
  //       titleKey: i18Key('settings.subtitle.sync'),
  //       desc: null,
  //     }),
  //     new ViewGroup({
  //       titleKey: i18Key('settings.subtitle.systemFolders'),
  //       desc: null,
  //       key: 'systemFolders',
  //     }),
  //   ]

  //   const mailboxProps = {
  //     useEmailSync: {
  //       labelKey: i18Key('settings.fields.useEmailSync'),
  //       readOnly: false,
  //       format: 'om-switch',
  //       default: true,
  //       vGroup: vGroups[0],
  //     },
  //     syncFrequency: {
  //       labelKey: i18Key('settings.fields.syncFrequency'),
  //       readOnly: false,
  //       format: 'om-select',
  //       default: -1,
  //       values: [
  //         { value: -1, labelKey: i18Key('settings.values.syncFrequency.auto') },
  //         { value: 0, labelKey: i18Key('settings.values.syncFrequency.none') },
  //         { value: 5, labelKey: i18Key('settings.values.syncFrequency.min5') },
  //         { value: 10, labelKey: i18Key('settings.values.syncFrequency.min10') },
  //         { value: 15, labelKey: i18Key('settings.values.syncFrequency.min15') },
  //         { value: 30, labelKey: i18Key('settings.values.syncFrequency.min30') },
  //         { value: 60, labelKey: i18Key('settings.values.syncFrequency.hour1') },
  //         { value: 120, labelKey: i18Key('settings.values.syncFrequency.hour2') },
  //         { value: 240, labelKey: i18Key('settings.values.syncFrequency.hour4') },
  //       ],
  //       vGroup: vGroups[0],
  //     },
  //     systemFoldersArchive: {
  //       useValue: false,
  //       labelKey: i18Key('settings.fields.systemFoldersArchive'),
  //       // readOnly: false,
  //       // format: 'om-input',
  //       format: 'custom',
  //       ...getCustomFolderSelect('archive', i18Key('settings.fields.systemFoldersArchive')),
  //       vGroup: vGroups[1],
  //     },
  //     systemFoldersJunk: {
  //       useValue: false,
  //       labelKey: i18Key('settings.fields.systemFoldersJunk'),
  //       // readOnly: false,
  //       // format: 'om-input',
  //       format: 'custom',
  //       ...getCustomFolderSelect('junk', i18Key('settings.fields.systemFoldersJunk')),
  //       vGroup: vGroups[1],
  //     },
  //     systemFoldersTrash: {
  //       useValue: false,
  //       labelKey: i18Key('settings.fields.systemFoldersTrash'),
  //       // readOnly: false,
  //       // format: 'om-input',
  //       format: 'custom',
  //       ...getCustomFolderSelect('trash', i18Key('settings.fields.systemFoldersTrash')),
  //       vGroup: vGroups[1],
  //     },
  //     systemFoldersDrafts: {
  //       useValue: false,
  //       labelKey: i18Key('settings.fields.systemFoldersDrafts'),
  //       // readOnly: false,
  //       // format: 'om-input',
  //       format: 'custom',
  //       ...getCustomFolderSelect('drafts', i18Key('settings.fields.systemFoldersDrafts')),
  //       vGroup: vGroups[1],
  //     },
  //     systemFoldersSent: {
  //       useValue: false,
  //       labelKey: i18Key('settings.fields.systemFoldersSent'),
  //       // readOnly: false,
  //       // format: 'om-input',
  //       format: 'custom',
  //       ...getCustomFolderSelect('sent', i18Key('settings.fields.systemFoldersSent')),
  //       vGroup: vGroups[1],
  //     },
  //   }

  //   this.uiGroupMap.mailbox = new UIGroup({
  //     children: mailboxProps,
  //     styles,
  //     reactObj: this,
  //   })
  // }

  createSignatureUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        // titleKey: i18Key('settings.subtitle.sync'),
        desc: null,
      }),
    ]

    const customObjManageSignatures: any = {
      onGetValue: (/* info, wrapper */) => {},
      onSetValue: (/* value, info, wrapper */) => {},
      getElement: (/* info, */ wrapper: any) => {
        const onClick = () => {
          console.log(' --- onClick : ', wrapper)
          const prevAccount = settings.getValue('account') ?? {}
          const prevSignatureForNew = prevAccount.signatureForNew
          const prevSignatureForReplyForward = prevAccount.signatureForReplyForward

          openManageSignature({
            afterClose: () => {
              console.log(' --- afterClose : ', wrapper)
              const account = settings.getValue('account') ?? {}
              const signatureForNew = account.signatureForNew
              const signatureForReplyForward = account.signatureForReplyForward

              const changed: Record<string, unknown> = {}
              if (signatureForNew !== prevSignatureForNew) {
                changed.signatureForNew = signatureForNew
              }

              if (signatureForReplyForward !== prevSignatureForReplyForward) {
                changed.signatureForReplyForward = signatureForReplyForward
              }
              if (Object.keys(changed).length > 0) {
                this.applyCurSignatures(changed)
              }
            },
          })
        }

        return (
          <OmButton key={wrapper.pKey} className={classNames('type3', 'h38')} onClick={onClick}>
            {i18n.t('settings.btns.manageSignatures')}
          </OmButton>
        )
      },
    }

    const signatureProps: any = {
      signatureForNew: {
        useValue: true,
        labelKey: i18Key('settings.fields.signatureForNew'),
        // readOnly: false,
        // format: 'om-input',
        format: 'custom',
        ...getCustomSignatureSelect(),
        vGroup: vGroups[0],
      },
      signatureForReplyForward: {
        useValue: true,
        labelKey: i18Key('settings.fields.signatureForReplyForward'),
        // readOnly: false,
        // format: 'om-input',
        format: 'custom',
        ...getCustomSignatureSelect(),
        vGroup: vGroups[0],
      },
      manageSignatures: {
        labelKey: null,
        format: 'custom',
        ...customObjManageSignatures,
        vGroup: vGroups[0],
      },
    }

    this.uiGroupMap.signature = new UIGroup({
      children: signatureProps,
      styles,
      reactObj: this,
    })
  }

  createSendAsUIGroup = (): void => {
    const vGroups = [
      new ViewGroup({
        titleKey: i18Key('settings.emailTabs.advanced'),
        descKey: null,
      }),
    ]

    const uiProps: any = {
      alwaysCc: {
        useValue: false,
        labelKey: i18Key('settings.fields.alwaysCc'),
        format: 'custom',
        ...getCustomSendAsSelect(settings.getValue('account').alwaysCc),
        vGroup: vGroups[0],
      },
      alwaysBcc: {
        useValue: false,
        labelKey: i18Key('settings.fields.alwaysBcc'),
        format: 'custom',
        ...getCustomSendAsSelect(settings.getValue('account').alwaysBcc),
        vGroup: vGroups[0],
      },
      replyTo: {
        useValue: false,
        labelKey: i18Key('settings.fields.replyTo'),
        format: 'om-input',
        default: '',
        vGroup: vGroups[0],
      },
    }

    this.uiGroupMap.sendAs = new UIGroup({
      children: uiProps,
      styles,
      reactObj: this,
    })
  }

  createServerRulesUIGroup = (): void => {
    const customObjManageServerRules: any = {
      onGetValue: (/* info, wrapper */) => {},
      onSetValue: (/* value, info, wrapper */) => {},
      getElement: (/* info, */ wrapper: any) => {
        const onClick = () => {
          openManageServerRules()
        }

        return (
          <div className={classNames(styles.alignRight)}>
            <OmButton key={wrapper.pKey} className={classNames('type3', 'h38')} onClick={onClick}>
              {i18n.t('settings.btns.manageServerRules')}
            </OmButton>
          </div>
        )
      },
    }

    const customObjManageSenders: any = {
      onGetValue: (/* info, wrapper */) => {},
      onSetValue: (/* value, info, wrapper */) => {},
      getElement: (/* info, */ wrapper: any) => {
        const onClick = () => {
          console.log(' --- onClick : ', wrapper)
          openManageSenders({
            // afterClose: () => {
            //   console.log(' --- afterClose : ', wrapper)
            //   this.applySettings()
            // },
          })
        }

        return (
          <div className={classNames(styles.alignRight)}>
            <OmButton key={wrapper.pKey} className={classNames('type3', 'h38')} onClick={onClick}>
              {i18n.t('settings.btns.manageSenders')}
            </OmButton>
          </div>
        )
      },
    }

    const filterVGroup = new ViewGroup({ titleKey: null, descKey: null })
    const sendersVGroup = new ViewGroup({ titleKey: null, descKey: null })

    const filterProps: any = {
      automaticFilter: {
        labelKey: i18Key('settings.fields.automaticFilter'),
        format: 'custom',
        ...customObjManageServerRules,
        vGroup: filterVGroup,
      },
    }

    const sendersProps: any = {
      manageSenders: {
        labelKey: i18Key('settings.fields.manageSenders'),
        format: 'custom',
        ...customObjManageSenders,
        vGroup: sendersVGroup,
      },
    }

    this.uiGroupMap.serverRulesFilter = new UIGroup({
      children: filterProps,
      styles,
      reactObj: this,
    })

    this.uiGroupMap.serverRulesSenders = new UIGroup({
      children: sendersProps,
      styles,
      reactObj: this,
    })
  }

  removeRemainAccount = (): void => {
    const { sendAsAccounts } = this.state
    const allSettings = settings.getAll()
    const accountSettings = allSettings.account ?? {}
    const alwaysCc = accountSettings.alwaysCc ?? allSettings.alwaysCc ?? {}
    const alwaysBcc = accountSettings.alwaysBcc ?? allSettings.alwaysBcc ?? {}

    const newAlwaysCc: any = {}
    Object.values(alwaysCc).forEach((account: any) => {
      if (sendAsAccounts.some((a) => a.email === account.email)) {
        newAlwaysCc[account.email] = account
      }
    })
    if (Object.keys(newAlwaysCc).length !== Object.keys(alwaysCc).length) {
      this.onPropsChange('alwaysCc', newAlwaysCc)
      this.uiGroupMap.sendAs.info.alwaysCc.wrapper.setValue(newAlwaysCc)
    }

    const newAlwaysBcc: any = {}
    Object.values(alwaysBcc).forEach((account: any) => {
      if (sendAsAccounts.some((a) => a.email === account.email)) {
        newAlwaysBcc[account.email] = account
      }
    })
    if (Object.keys(newAlwaysBcc).length !== Object.keys(alwaysBcc).length) {
      this.onPropsChange('alwaysBcc', newAlwaysBcc)
      this.uiGroupMap.sendAs.info.alwaysBcc.wrapper.setValue(newAlwaysBcc)
    }
  }

  applyCurSignatures = (changed: Record<string, unknown>): void => {
    const { owner } = this.props
    owner.defaultValues.account ??= {}
    Object.keys(changed).forEach((key) => {
      owner.defaultValues.account[key] = changed[key]
      owner.onChangeValue(this.toCategoryKey(key), changed[key])
    })
    this.uiGroupMap.signature.setValue(
      {
        ...changed,
      },
      true,
    )
  }

  applySettings = (): void => {
    const clone = settings.getAll()
    const accountValues = { ...clone, ...(clone.account ?? {}) }

    // this.uiGroupMap.mailbox.setValue(clone, true)
    this.uiGroupMap.account.setValue(accountValues, true)
    this.uiGroupMap.signature.setValue(accountValues, true)
    this.uiGroupMap.sendAs.setValue(accountValues, true)
  }

  // UIGroup pKey → 카테고리 dot-path 변환
  private toCategoryKey = (key: string): string => {
    const ACCOUNT_KEYS = new Set([
      'accountName',
      'accountColor',
      'accountSenderName',
      'alwaysCc',
      'alwaysBcc',
      'replyTo',
      'signatureForNew',
      'signatureForReplyForward',
    ])
    if (ACCOUNT_KEYS.has(key)) return `account.${key}`
    return key
  }

  onPropsChange = (key: string, value: any): void => {
    if (key === 'replyTo') {
      if (!isEmail(value) && value !== '') {
        value = ''
      }
    }

    const { owner } = this.props

    if (owner != null && owner.onChangeValue != null) {
      owner.onChangeValue(this.toCategoryKey(key), value)
    }
  }

  getTabsAttrs = (): any => {
    const { owner, isMobile, parentLabel, idx } = this.props
    const { t } = i18n

    if (this.uiGroupMap.account == null) {
      this.createAccountUIGroup()
    }
    // if (this.uiGroupMap.mailbox == null) {
    //   this.createMailboxUIGroup()
    // }
    if (this.uiGroupMap.signature == null) {
      this.createSignatureUIGroup()
    }

    if (this.uiGroupMap.sendAs == null) {
      this.createSendAsUIGroup()
    }

    if (this.uiGroupMap.serverRulesFilter == null) {
      this.createServerRulesUIGroup()
    }

    let defaultActiveKey: string | null = null
    const { selectedTabs } = owner
    if (selectedTabs != null && selectedTabs.length > 1) {
      defaultActiveKey = selectedTabs[1]
    }

    const rawServices = getTempEnvParam('app.services')
    // app.services 는 로그아웃(강제 로그아웃 포함) 정리 시 제거될 수 있어 pages 를 항상 객체로 방어.
    const services = {
      ...(rawServices ?? {}),
      pages: rawServices?.pages ?? {},
    }

    let items: any[] = [
      {
        key: 'accounts',
        label: (
          <div className={classNames('tabItem', 'info', styles.info)}>
            <div className={classNames(styles.label)}>{t('settings.accountTabs.info')}</div>
          </div>
        ),
        children: (
          <div className={classNames('panel', 'info', styles.info)}>
            {this.uiGroupMap.account.getElement()}
          </div>
        ),
      },
    ]

    if (services.pages.email === true) {
      items = [
        ...items,
        // {
        //   key: 'mailbox',
        //   label: (
        //     <div className={classNames('tabItem', styles.mailbox)}>
        //       <div className={classNames(styles.label)}>{t('settings.accountTabs.mailbox')}</div>
        //     </div>
        //   ),
        //   children: (
        //     <div className={classNames('panel', styles.mailbox)}>
        //       {this.uiGroupMap.mailbox.getElement()}
        //     </div>
        //   ),
        // },
        {
          key: 'signatures',
          label: (
            <div className={classNames('tabItem', 'signature', styles.signature)}>
              <div className={classNames(styles.label)}>{t('settings.accountTabs.signature')}</div>
            </div>
          ),
          children: (
            <div className={classNames('panel', 'signature', styles.signature)}>
              {this.uiGroupMap.signature.getElement()}
            </div>
          ),
        },
        // {
        //   key: 'sendMail',
        //   label: (
        //     <div className={classNames('tabItem', styles.sendMail)}>
        //       <div className={classNames(styles.label)}>{t('settings.accountTabs.sendMail')}</div>
        //     </div>
        //   ),
        //   children: <div className={classNames('panel', styles.sendMail)}>Send Mail</div>,
        // },
        // {
        //   key: 'serverSettings',
        //   label: (
        //     <div className={classNames('tabItem', styles.serverSettings)}>
        //       <div className={classNames(styles.icon)} />
        //       <div className={classNames(styles.label)}>
        //         {t('settings.accountTabs.serverSettings')}
        //       </div>
        //     </div>
        //   ),
        //   children: <div className={classNames('panel', styles.serverSettings)}>ServerSettings</div>,
        // },
        {
          key: 'sendAs',
          label: (
            <div className={classNames('tabItem', 'sendAs', styles.sendAs)}>
              <div className={classNames(styles.label)}>{t('settings.accountTabs.sendAs')}</div>
            </div>
          ),
          children: (
            <div className={classNames('panel', 'sendAsAdvanced', styles.sendAsAdvanced)}>
              <SendAsPanel
                active={this.state.activeKey === 'sendAs'}
                onLoadAccounts={(accounts: any[]) => {
                  this.setState({ sendAsAccounts: accounts })
                  this._removeRemainTimer = setTimeout(() => {
                    this.removeRemainAccount()
                  }, 50)
                }}
                onRemoveAccount={(account: any) => {
                  this.setState({
                    sendAsAccounts: this.state.sendAsAccounts.filter((a) => a.id !== account.id),
                  })
                  this._removeRemainTimer = setTimeout(() => {
                    this.removeRemainAccount()
                  }, 50)
                }}
              />
              {this.uiGroupMap.sendAs.getElement()}
            </div>
          ),
        },
        {
          key: 'forwarding',
          label: (
            <div className={classNames('tabItem', 'forwarding', styles.forwarding)}>
              <div className={classNames(styles.label)}>{t('settings.accountTabs.forwarding')}</div>
            </div>
          ),
          children: (
            <div className={classNames('panel', 'forwarding', styles.forwarding)}>
              <ForwardingPanel active={this.state.activeKey === 'forwarding'} />
            </div>
          ),
        },
        {
          key: 'appPassword',
          label: (
            <div className={classNames('tabItem', 'appPassword', styles.appPassword)}>
              <div className={classNames(styles.label)}>
                {t('settings.accountTabs.appPassword')}
              </div>
            </div>
          ),
          children: (
            <div className={classNames('panel', 'appPassword', styles.appPassword)}>
              <AppPasswordPanel active={this.state.activeKey === 'appPassword'} />
            </div>
          ),
        },
        {
          key: 'automaticReplies',
          label: (
            <div className={classNames('tabItem', 'automaticReplies', styles.automaticReplies)}>
              <div className={classNames(styles.label)}>
                {t('settings.accountAutomaticRepliesTab.automaticReplies')}
              </div>
            </div>
          ),
          children: (
            <div className={classNames('panel', 'automaticReplies', styles.automaticReplies)}>
              <AutomaticRepliesPanel active={this.state.activeKey === 'automaticReplies'} />
            </div>
          ),
        },
        {
          key: 'serverRules',
          label: (
            <div className={classNames('tabItem', 'serverRules', styles.serverRules)}>
              <div className={classNames(styles.label)}>{t('settings.tabs.serverRules')}</div>
            </div>
          ),
          children: (
            <div className={classNames('panel', 'info', styles.info)}>
              {this.uiGroupMap.serverRulesFilter.getElement()}
              <div className={classNames(styles.filterDesc)}>
                {t('settings.fields.automaticFilterDesc')}
              </div>
              {this.uiGroupMap.serverRulesSenders.getElement()}
            </div>
          ),
        },
      ]
    }

    const tabsAttrs: any = {
      className: classNames('subTabs'),
      popupClassName: classNames('contextMenu'),
      items,
      centered: true,
      tabPosition: 'left',
      tabBarExtraContent: isMobile ? { left: parentLabel } : null,
      onChange: (activeKey: string) => {
        this.setState({
          activeKey,
        })
      },
      onTabClick: (activeKey: string) => {
        const item = items.find((item) => item.key === activeKey)
        if (item != null) {
          const index = parseInt(idx as string, 10)
          owner.mobileViewObj.setKey(1, activeKey, [parentLabel, item.label], index)
        }
      },
    }

    if (defaultActiveKey != null) {
      tabsAttrs.defaultActiveKey = defaultActiveKey
    }

    return tabsAttrs
  }

  render(): React.ReactNode {
    const tabsAttrs = this.getTabsAttrs()

    return (
      <div className={classNames(styles.accounts)}>
        <OmTabs {...tabsAttrs} />
      </div>
    )
  }
}

export default SettingItem
